import React, { useState, useEffect, useCallback } from 'react'
import { IoCaretBackCircle } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import SkeletonVideoCard from '../../components/skeleton/SkeletonVideoCard';
import VideoCard from '../../components/common/VideoCard';
import useSelectVideo from '../../hooks/useSelectVideo';
import { getOtherUserReshare } from '../../redux/ApiSlice/ResharedSlice';

export default function Reshared() {
    const { userId } = useParams();
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredList, setFilteredList] = useState([]);
    const [pageCount, setPageCount] = useState(1);
    const [isLoadingMore, setIsLoadingMore] = useState(false);

    const otheruser_id = userId
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const selectVideo = useSelectVideo();
    const location = useLocation();

    const { reSharedList, loading, hasMore, error } = useSelector((state) => state.resharedPosts);

    const filteredByResharedPosts = reSharedList?.reposts?.map((item) => (item.original_post));

    const handleSelectVideo = async (id) => {
        selectVideo(id, filteredByResharedPosts, location.pathname);
    };

    // Load initial data
    useEffect(() => {
        if (otheruser_id) {
            dispatch(getOtherUserReshare({ userId: otheruser_id, pageCount: 1 }));
            setPageCount(1);
        }
    }, [dispatch, otheruser_id]);


    useEffect(() => {
        if (reSharedList?.reposts) {
            setFilteredList(reSharedList.reposts);
        }
    }, [reSharedList]);


    // Load more data for pagination
    const loadMoreData = useCallback(async () => {
        if (hasMore && !loading && !isLoadingMore && otheruser_id) {
            setIsLoadingMore(true);
            const nextPage = pageCount + 1;
            await dispatch(getOtherUserReshare({ userId: otheruser_id, pageCount: nextPage }));
            setPageCount(nextPage);
            setIsLoadingMore(false);
        }
    }, [dispatch, hasMore, loading, isLoadingMore, pageCount, otheruser_id]);

    // Infinite scroll handler
    const handleScroll = useCallback((e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollHeight - scrollTop <= clientHeight + 100) {
            loadMoreData();
        }
    }, [loadMoreData]);



    return (
        <section className="h-full bg-white dark:bg-[#1E1D21]">
            <div className="sticky top-0">
                <div className="flex items-center justify-center h-12 bg-[#BDE6FF] rounded-b-xl px-2">
                    <IoCaretBackCircle
                        onClick={() => navigate(-1)}
                        className="text-[24px] text-black absolute top-1/2 left-2 transform -translate-y-1/2 cursor-pointer"
                    />
                    <p className="text-[16px] font-semibold text-black">
                        Reshared Posts
                    </p>
                </div>
            </div>

            <>
                {loading && pageCount === 1 ? (
                    <SkeletonVideoCard />
                ) : (
                    <>
                        <div
                            className="grid grid-cols-2 p-2 gap-2 overflow-y-scroll h-full"
                            onScroll={handleScroll}
                        >
                            {filteredList?.map((item) => (
                                <VideoCard
                                    key={item.original_post.id}
                                    id={item.original_post.id}
                                    belowDecs={true}
                                    body={item.original_post.post_description}
                                    threeDots={false}
                                    video={item.original_post.video_url}
                                    user_id={item.original_post.created_by?.id}
                                    authorId={item.original_post.created_by?.id}
                                    view_count={item.original_post.view_count}
                                    likes_count={item.original_post.likes_count}
                                    selectVideo={handleSelectVideo}
                                    avatar_url={item.original_post.created_by?.avatar_url}
                                />
                            ))}
                            {(isLoadingMore || (loading && pageCount > 1)) && (
                                <div className="col-span-2 flex justify-center items-center py-4">
                                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                                </div>
                            )}
                        </div>
                    </>
                )}

                {filteredList?.length === 0 && !loading && (
                    <div className="flex justify-center items-center h-64">
                        <p className="text-[12px] text-gray-400 dark:text-gray-500">
                            No reshared posts
                        </p>
                    </div>
                )}

                {error && (
                    <div className="flex justify-center items-center h-64">
                        <p className="text-[12px] text-red-500">
                            Error loading posts. Please try again.
                        </p>
                    </div>
                )}
            </>
        </section>
    )
}
